import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { LoginPage } from 'modules/auth'
import { AccountPage } from 'modules/account'
import { NotificationsPage } from 'modules/notifications'
import NotFoundPage from 'modules/core/components/NotFound'
import { CatalogPage } from 'modules/catalog'
import { ROUTES } from 'modules/navigation'
import { PrivateRoute } from 'modules/navigation'
import {
	ApprovalListPage,
	SelectContractRegionsPage,
	SelectRequirementsPage,
	JustificationsPage,
	ContentCheckDetailsPage,
	SystemInfoPage,
	SystemCostsPage
} from 'modules/approval'
import RegistrationRequestPage from '../auth/containers/RegistrationRequestPage'
import ChangePasswordPage from '../account/containers/ChangePasswordPage'
import PasswordResetRequestPage from '../auth/containers/PasswordResetRequestPage'
import PasswordResetConfirmPage from '../auth/containers/PasswordResetConfirmPage'
import { AcceptTermsOfUsePage } from '../core/containers/AcceptTermsOfUsePage'
import { LicenseAgreementPage } from '../license'
import ContactPage from '../contact/containers/ContactPage'
import ImprintPage from '../imprint/containers/ImprintPage'
import SealTermsPage from '../sealTerms/containers/SealTermsPage'
import faqPage from '../faq/containers/faqPage'
import TermsOfUsePage from 'modules/termsOfUse/containers/TermsOfUsePage'
import PrivacyPolicyPage from 'modules/privacyPolicy/containers/PrivacyPolicy'
import HpmSecurityIncidentPage from '../outreach/containers/HpmSecurityIncidentPage'

export default () => (
	<Switch>
		<PrivateRoute path={ROUTES.home} component={NotificationsPage} exact />
		<Route path={ROUTES.login} component={LoginPage} />
		<Route path={ROUTES.registration} component={RegistrationRequestPage} />
		<PrivateRoute
			path={ROUTES.securityIncident}
			component={HpmSecurityIncidentPage}
		/>
		<Route
			path={ROUTES.publicSecurityIncident}
			render={() => <HpmSecurityIncidentPage requiresCaptcha />}
		/>
		<Route path={ROUTES.passwordReset} component={PasswordResetRequestPage} />
		<Route
			path={ROUTES.passwordResetConfirm}
			component={PasswordResetConfirmPage}
		/>
		<PrivateRoute path={`${ROUTES.catalog}/:id`} component={CatalogPage} />
		<PrivateRoute
			path={`${ROUTES.approval.report.systemInfo}`}
			component={SystemInfoPage}
		/>
		<PrivateRoute
			path={`${ROUTES.approval.report.systemCosts}`}
			component={SystemCostsPage}
		/>
		<PrivateRoute
			exact
			path={`${ROUTES.approval.base}/:quarter`}
			component={ApprovalListPage}
		/>
		<PrivateRoute
			path={ROUTES.approval.contentCheck.contentCheckDetails}
			component={ContentCheckDetailsPage}
		/>
		<PrivateRoute
			path={ROUTES.approval.report.selectContractRegions}
			component={SelectContractRegionsPage}
		/>
		<PrivateRoute
			path={ROUTES.approval.report.selectRequirements}
			component={SelectRequirementsPage}
		/>
		<PrivateRoute
			path={ROUTES.approval.report.justifications}
			component={JustificationsPage}
		/>
		<PrivateRoute path={ROUTES.account.base} component={AccountPage} exact />
		<PrivateRoute
			path={ROUTES.account.changePassword}
			component={ChangePasswordPage}
		/>
		<PrivateRoute
			path={ROUTES.core.acceptTermsOfUse}
			component={AcceptTermsOfUsePage}
		/>
		<PrivateRoute
			path={ROUTES.licenseAgreements}
			component={LicenseAgreementPage}
		/>
		<Route path={ROUTES.contact} component={ContactPage} exact />
		<Route path={ROUTES.imprint} component={ImprintPage} exact />
		<Route path={ROUTES.sealTerms} component={SealTermsPage} exact />
		<Route path={ROUTES.termsOfUse} component={TermsOfUsePage} exact />
		<Route path={ROUTES.privacyPolicy} component={PrivacyPolicyPage} exact />
		<PrivateRoute path={ROUTES.faq} component={faqPage} exact />
		<Route path={ROUTES.notFound} component={NotFoundPage} exact />
	</Switch>
)
